import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { utility, colors, spacing, breakpoints, typography } = useTheme();

  return {
    btn: ({ isGender, isConfirmation }) => {
      return css`
        ${utility.buttonDefault};
        line-height: 1.375rem;
        position: relative;
        z-index: 1;
        display: inline-block;
        color: ${colors.white};
        width: auto;
        max-width: 460px;
        max-height: 120px;
        text-align: left;
        font-family: 'FS Dillon';
        font-size: 18px;
        font-weight: 700;
        height: 48px;
        transition: background-color 0.3s ease-in;

        ${breakpoints.xxl} {
          &:hover {
            color: ${colors.navy};
          }
        }

        ${isConfirmation === true &&
        css`
          &:not(:disabled) {
            &:hover {
              background-color: unset;
            }
          }
          ${breakpoints.m} {
            &:hover {
              &::before {
                background-color: ${colors.white};
              }

              span {
                color: ${colors.navy};
              }
            }
          }
        `}
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 327px;
        }

        svg {
          margin-right: ${spacing.xs};
        }

        &::before {
          content: '';
          display: block;
          position: absolute;
          z-index: -1;
          bottom: 0;
          left: 0;
          width: 323px;
          height: 48px;
          background-size: 55%;
          border: 2px solid ${colors.white};
          border-radius: 4px;

          ${breakpoints.l} {
            width: 387px;
            height: 44px;
          }
        }

        ${isGender === false &&
        css`
          &:hover {
            &::before {
              background-color: ${colors.white};
              color: ${colors.navy};
            }
          }
        `}

        ${isGender === true &&
        css`
          ${breakpoints.xxl} {
            &:hover {
              &::before {
                background-color: ${colors.white};
              }
            }
          }
          &::before {
            background-size: 55%;
          }
        `}

        ${breakpoints.l} {
          font-size: 18px;
          padding: 0 !important;

          span {
            width: 391px;
          }

          &::before {
            background-size: 55%;
          }
        }

        &:focus-visible {
          span {
            text-decoration: underline;
            color: ${colors.border_black};
          }
          &::before {
            border: 2px solid ${colors.border_black} !important;
            outline: none;
            border-radius: 4px;
            background-color: ${colors.skip_yellow};
          }
        }
      `;
    },
    description: css`
      font-size: 0.8rem;
      font-weight: 400;
      color: ${colors.darkGrey};

      ${breakpoints.l} {
        ${typography.base};
      }
    `,
    image: css`
      display: block;
      position: absolute;
      bottom: 0;
      right: 0;
    `,
  };
};
